import { connect } from 'react-redux';
import { checkTrust, resign } from '../actions';
import Verified from '../components/Verified';


const mapStateToProps = state => ({
  route: state.route,
  isFailure: state.verifyStatus.isFailure,
  rememberMe: state.loginStatus.rememberMe
});

const mapDispatchToProps = dispatch => ({
  onCheckClick: () => {
    dispatch(checkTrust());
  },
  resign: () => {
    dispatch(resign());
  }
});


export default connect(mapStateToProps, mapDispatchToProps)(Verified);



/** WEBPACK FOOTER **
 ** ./src/containers/VerifiedContainer.jsx
 **/